<template>
	<div class="PagePartnerOverview">
		<div class="row margin-bottom-xlarge">
    		<div class="col-xs-12">
    			<h1 class="st-headline st-headline--1">{{ $t('Partners') }}</h1>
    		</div>
    	</div>

		<div class="row margin-bottom-xlarge margin-top-xlarge">
    		<div class="col-xs-12">
    			<UserList
				:apiurl="'/api/v1/partners'"
				:columns="['image', 'this', 'leader', 'managers', 'customers']"
				:listname="'partners'"
				></UserList>
    		</div>
    	</div>
	</div>

</template>

<script>
import UserList from '@/components/UserList';
export default {
	name: 'PagePartnerOverview',
	components: {
		UserList
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PagePartnerOverview.vue